import React from 'react';
import { DEFAULT_VALUE_0 } from 'common/config';
import { getId } from 'common/helpers/common.helper';
import { Affiliate, Delivery, User } from 'common/svg';
import { ERequestHistoryType } from 'entities/RequestHistory/RequestHistory.enum';
import {
  IGroupedRequestHistoryGroup,
  IRequestHistory,
  IRequestHistoryGroup,
} from 'entities/RequestHistory/RequestHistory.models';

const requestHistoryTypesForView = [
  ERequestHistoryType.Comment,
  ERequestHistoryType.RequestCreated,
  ERequestHistoryType.SupplyAddedToRequest,
  ERequestHistoryType.SupplyStatusChanged,
  ERequestHistoryType.SupplyPriceChanged,
];

export const groupRequestHistoryByTypeUserAndChanges = (historyList: IRequestHistory[]) => {
  const filteredHistoryList = historyList.filter((history) => {
    return requestHistoryTypesForView.includes(history.type as ERequestHistoryType);
  });
  const result: IRequestHistoryGroup[] = [];
  let group: IRequestHistory[] = [];

  filteredHistoryList.forEach((history, index) => {
    if (index === 0) {
      group.push(history);
    } else {
      const prevLog = filteredHistoryList[index - 1];

      if (
        history.type === ERequestHistoryType.SupplyStatusChanged &&
        history.type === prevLog.type &&
        history.user?.id === prevLog.user?.id &&
        JSON.stringify(history.changes) === JSON.stringify(prevLog.changes)
      ) {
        group.push(history);
      } else {
        const lastHistoryOfGroup = group[group.length - 1];

        result.push({
          key: getId(),
          createdAt: lastHistoryOfGroup.createdAt,
          type: lastHistoryOfGroup.type,
          isCancelledBySeller: lastHistoryOfGroup.isCancelledBySeller,
          user: lastHistoryOfGroup.user,
          comment: lastHistoryOfGroup.comment,
          goodImage: lastHistoryOfGroup.goodImage,
          isNew: lastHistoryOfGroup.isNew,
          changes: lastHistoryOfGroup.changes,
          files: lastHistoryOfGroup.files,
          logs: group,
        });
        group = [history];
      }
    }
  });

  if (group.length > DEFAULT_VALUE_0) {
    const lastHistoryOfGroup = group[group.length - 1];

    result.push({
      key: getId(),
      createdAt: lastHistoryOfGroup.createdAt,
      type: lastHistoryOfGroup.type,
      isCancelledBySeller: lastHistoryOfGroup.isCancelledBySeller,
      user: lastHistoryOfGroup.user,
      comment: lastHistoryOfGroup.comment,
      goodImage: lastHistoryOfGroup.goodImage,
      isNew: lastHistoryOfGroup.isNew,
      changes: lastHistoryOfGroup.changes,
      files: lastHistoryOfGroup.files,
      logs: group,
    });
  }

  return result;
};

export const groupRequestHistoryGroupsByType = (historyList: IRequestHistory[]) => {
  const groupedRequestHistory = groupRequestHistoryByTypeUserAndChanges(historyList);
  const result: IGroupedRequestHistoryGroup[] = [];
  let group: IRequestHistoryGroup[] = [];

  groupedRequestHistory.forEach((item, index) => {
    if (index === 0) {
      group.push(item);
    } else {
      const prevGroup = groupedRequestHistory[index - 1];

      if (item.type === prevGroup.type) {
        group.push(item);
      } else {
        const lastGroup = group[group.length - 1];

        result.push({
          key: getId(),
          type: lastGroup.type,
          logs: group,
        });
        group = [item];
      }
    }
  });

  if (group.length > DEFAULT_VALUE_0) {
    const lastGroup = group[group.length - 1];

    result.push({
      key: getId(),
      type: lastGroup.type,
      logs: group,
    });
  }
  return result;
};

export const renderRequestHistoryItemIcon = (type: string) => {
  switch (type) {
    case ERequestHistoryType.RequestCreated: {
      return <User className="icon-user-dark-grey" />;
    }
    case ERequestHistoryType.SupplyStatusChanged: {
      return <Affiliate className="icon-affiliate-dark-grey" />;
    }
    case ERequestHistoryType.SupplyAddedToRequest:
    case ERequestHistoryType.SupplyPriceChanged:
    case ERequestHistoryType.Comment: {
      return <Delivery className="icon-delivery-dark-grey" />;
    }
    default: {
      return null;
    }
  }
};

export const getRequestHistoryItemDescription = (type: string) => {
  switch (type) {
    case ERequestHistoryType.RequestCreated: {
      return 'создан новый заказ';
    }
    case ERequestHistoryType.SupplyStatusChanged: {
      return 'изменен статус заказа';
    }
    case ERequestHistoryType.SupplyAddedToRequest: {
      return 'добавлен новый товар';
    }
    case ERequestHistoryType.SupplyPriceChanged: {
      return 'скорректирована цена товара';
    }
    case ERequestHistoryType.Comment: {
      return 'оставлен комментарий';
    }
    default: {
      return null;
    }
  }
};
